// Shared motion presets for BrandPage sub-components. Hoisted to module
// scope so they are not re-created on every render.
export const FADE_UP_INITIAL = { opacity: 0, y: 24 };
export const FADE_UP_ANIMATE = { opacity: 1, y: 0 };
export const VIEWPORT_ONCE = { once: true, margin: "-80px" };
export const HERO_INITIAL = { opacity: 0, scale: 0.96, y: 20 };
export const HERO_ANIMATE = { opacity: 1, scale: 1, y: 0 };
export const HERO_TRANSITION = { duration: 0.8, ease: [0.22, 1, 0.36, 1] };
export const FADE_UP_TRANSITION = { duration: 0.9 };
